var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"desktop-services"},[_c('Banner'),_c('Content'),_c('Location')],1)}
var staticRenderFns = []

export { render, staticRenderFns }